export const hasStoredFormEventId = (id) => {
	let formEventIds = window.localStorage.getItem('formEventIds');
	formEventIds = formEventIds ? JSON.parse(formEventIds) : [];
	return formEventIds.indexOf(id) > -1;
};

export const storeFormEventId = (id) => {
	let formEventIds = localStorage.getItem('formEventIds');
	formEventIds = formEventIds ? JSON.parse(formEventIds) : [];
	formEventIds.push(id);
	formEventIds = JSON.stringify(formEventIds);
	window.localStorage.setItem('formEventIds', formEventIds);
};
